/**
 * Hero carousel: autoplay, arrows, dots and pause-on-hover/focus.
 *
 * Requires the `strichwerke` namespace from global.js.
 */

strichwerke.Carousel = {
  init: function () {
    const carousels = document.querySelectorAll("[data-hero-carousel]");
    carousels.forEach((carousel) => this.setupCarousel(carousel));
  },

  setupCarousel: function (carousel) {
    const track = carousel.querySelector("[data-carousel-track]");
    const slides = carousel.querySelectorAll("[data-carousel-slide]");
    const prevButton = carousel.querySelector("[data-carousel-prev]");
    const nextButton = carousel.querySelector("[data-carousel-next]");
    const dots = carousel.querySelectorAll("[data-carousel-dot]");
    const interval = parseInt(carousel.dataset.interval, 10) || 6000;

    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;

    const update = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute(
          "aria-hidden",
          slideIndex === index ? "false" : "true",
        );
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute(
          "aria-selected",
          dotIndex === index ? "true" : "false",
        );
      });
    };

    const play = () => {
      if (timer) clearInterval(timer);
      timer = setInterval(() => update(index + 1), interval);
    };

    const pause = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    prevButton?.addEventListener("click", () => {
      update(index - 1);
      play();
    });

    nextButton?.addEventListener("click", () => {
      update(index + 1);
      play();
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const dotIndex = parseInt(dot.dataset.index, 10);
        if (!Number.isNaN(dotIndex)) {
          update(dotIndex);
          play();
        }
      });
    });

    carousel.addEventListener("mouseenter", pause);
    carousel.addEventListener("mouseleave", play);
    carousel.addEventListener("focusin", pause);
    carousel.addEventListener("focusout", play);

    update(0);
    play();
  },
};
